import { createBrowserRouter, Outlet } from 'react-router-dom';
import Layout from '@/components/layout/layout/Layout';
import Dashboard from '@/page/admin/dashboard/Dashboard';
import Login from '@/page/common/login/Login';
import AlertSample from '@/page/admin/sample/alert/AlertSample';
import ProtectedRoute from '@components/common/Route/ProtectedRoute';
import CorporationList from '@/page/admin/user/corparation/CorporationList';
import WorkerList from '@/page/admin/user/WorkerList';
import FarmerList from '@/page/admin/user/FarmerList';
import CorporationDetail from '@/page/admin/user/corparation/CorporationDetail';
import CorporationAdd from '@/page/admin/user/corparation/CorporationAdd';
import Season from '@/page/admin/growth/season/Season';
import SeasonAdd from '@/page/admin/growth/season/SeasonAdd';
import SeasonDetail from '@/page/admin/growth/season/SeasonDetail';
import Farmland from '@/page/admin/farmland/Farmland';
import StationList from '@/page/admin/weather/station/StationList';
import AreaList from '@/page/admin/weather/area/AreaList';
import AreaAdd from '@/page/admin/weather/area/AreaAdd';
import AreaDetail from '@/page/admin/weather/area/AreaDetail';
import WeatherList from '@/page/admin/weather/weather/WeatherList';
import WeatherScheduleLogList from '@/page/admin/weather/log/WeatherScheduleLogList';
import SampleGrowthDashboard from '@/page/admin/growth/dashboard_sample/SampleGrowthDashboard';
import GrowthDashboard from '@/page/admin/growth/dashboard/GrowthDashboard';
import AgencyDashboard from '@/page/agency/dashboard/AgencyDashboard';
import CorporationUserDetail from '@/page/agency/user/CorporationUserDetail';
import Join from '@/page/common/join/Join';
import TermsViewer from '@/page/common/join/TermsViewer';
import AttendanceCheck from '@/page/check/AttendanceCheck';
import RootRedirect from './RootRedirect';
import { Navigate } from 'react-router-dom';
import { DemoProvider } from '@/page/demo/DemoContext';
import DemoLayout from '@/page/demo/DemoLayout';
import DemoLogin from '@/page/demo/DemoLogin';
import DemoJoin from '@/page/demo/DemoJoin';
import DemoPending from '@/page/demo/DemoPending';
import DemoDashboard from '@/page/demo/DemoDashboard';
import DemoSiteList from '@/page/demo/DemoSiteList';
import DemoSiteDetail from '@/page/demo/DemoSiteDetail';
import DemoIrrigation from '@/page/demo/DemoIrrigation';
import DemoReports from '@/page/demo/DemoReports';
import DemoSensors from '@/page/demo/DemoSensors';
import DemoSettings from '@/page/demo/DemoSettings';
import { Demo2Provider } from '@/page/demo2/Demo2Context';
import Demo2WebLayout from '@/page/demo2/layout/Demo2WebLayout';
import Demo2MobileLayout from '@/page/demo2/layout/Demo2MobileLayout';
import Demo2Login from '@/page/demo2/web/Demo2Login';
import Demo2Dashboard from '@/page/demo2/web/Demo2Dashboard';
import Demo2Map from '@/page/demo2/web/Demo2Map';
import Demo2TreeList from '@/page/demo2/web/Demo2TreeList';
import Demo2TreeDetail from '@/page/demo2/web/Demo2TreeDetail';
import Demo2Moisture from '@/page/demo2/web/Demo2Moisture';
import Demo2Alerts from '@/page/demo2/web/Demo2Alerts';
import Demo2WorkManagement from '@/page/demo2/web/Demo2WorkManagement';
import Demo2WorkHistory from '@/page/demo2/web/Demo2WorkHistory';
import Demo2Reports from '@/page/demo2/web/Demo2Reports';
import Demo2Settings from '@/page/demo2/web/Demo2Settings';
import Demo2MLogin from '@/page/demo2/mobile/Demo2MLogin';
import Demo2MHome from '@/page/demo2/mobile/Demo2MHome';
import Demo2MWorklist from '@/page/demo2/mobile/Demo2MWorklist';
import Demo2MWorkProcess from '@/page/demo2/mobile/Demo2MWorkProcess';
import Demo2MMap from '@/page/demo2/mobile/Demo2MMap';
import Demo2MMoisture from '@/page/demo2/mobile/Demo2MMoisture';
import Demo2MHistory from '@/page/demo2/mobile/Demo2MHistory';

const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <ProtectedRoute>
                <Layout />
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <RootRedirect />,
            },
            {
                path: 'dashboard',
                element: <Dashboard />,
            },
            {
                path: 'corporation',
                element: <CorporationList />,
            },
            {
                path: 'corporation/:userIdx',
                element: <CorporationDetail />,
            },
            {
                path: 'corporation/add',
                element: <CorporationAdd />,
            },
            {
                path: 'season',
                element: <Season />,
            },
            {
                path: 'season/add',
                element: <SeasonAdd />,
            },
            {
                path: 'season/:gsIdx',
                element: <SeasonDetail />,
            },
            {
                path: 'farmland/:gsIdx?',
                element: <Farmland />,
            },
            {
                path: 'growth/dashboard/sample',
                element: <SampleGrowthDashboard />,
            },
            {
                path: 'growth/dashboard/:gfIdx?',
                element: <GrowthDashboard />,
            },
            {
                path: 'worker',
                element: <WorkerList />,
            },
            {
                path: 'farmer',
                element: <FarmerList />,
            },
            {
                path: 'sample/alert',
                element: <AlertSample />,
            },
            {
                path: 'weather/station',
                element: <StationList />,
            },
            {
                path: 'weather/area',
                element: <AreaList />,
            },
            {
                path: 'weather/area/add',
                element: <AreaAdd />,
            },
            {
                path: 'weather/area/:areaIdx',
                element: <AreaDetail />,
            },
            {
                path: 'weather',
                element: <WeatherList />,
            },
            {
                path: 'weather/log',
                element: <WeatherScheduleLogList />,
            },
            {
                path: 'user/dashboard',
                element: <AgencyDashboard />,
            },
            {
                path: 'user/info',
                element: <CorporationUserDetail />,
            },
        ],
    },
    {
        path: '/login',
        element: <Login />,
    },
    {
        path: '/join/sns',
        element: <Join />,
    },
    {
        path: '/terms/:type',
        element: <TermsViewer />,
    },
    {
        /** 출퇴근체크 임시페이지 **/
        path: '/check/attendance',
        element: <AttendanceCheck />,
    },
    /* ─── GreenMap Water Demo ─── */
    {
        path: '/demo',
        element: (
            <DemoProvider>
                <Outlet />
            </DemoProvider>
        ),
        children: [
            { index: true, element: <Navigate to="/demo/login" replace /> },
            { path: 'login', element: <DemoLogin /> },
            { path: 'join', element: <DemoJoin /> },
            { path: 'pending', element: <DemoPending /> },
            {
                element: <DemoLayout />,
                children: [
                    { path: 'dashboard', element: <DemoDashboard /> },
                    { path: 'sites', element: <DemoSiteList /> },
                    { path: 'sites/:id', element: <DemoSiteDetail /> },
                    { path: 'irrigation', element: <DemoIrrigation /> },
                    { path: 'reports', element: <DemoReports /> },
                    { path: 'sensors', element: <DemoSensors /> },
                    { path: 'settings', element: <DemoSettings /> },
                ],
            },
        ],
    },
    /* ─── LH & 수프로 수목관리 시스템 데모 (React, 실제 지도) ─── */
    {
        path: '/demo2',
        element: (
            <Demo2Provider>
                <Outlet />
            </Demo2Provider>
        ),
        children: [
            { index: true, element: <Navigate to="/demo2/web/dashboard" replace /> },
            { path: 'web/login', element: <Demo2Login /> },
            { path: 'mobile/login', element: <Demo2MLogin /> },
            { path: 'mobile/work-process/:id', element: <Demo2MWorkProcess /> },
            {
                element: <Demo2WebLayout />,
                children: [
                    { path: 'web/dashboard', element: <Demo2Dashboard /> },
                    { path: 'web/map', element: <Demo2Map /> },
                    { path: 'web/tree-list', element: <Demo2TreeList /> },
                    { path: 'web/tree-detail/:id', element: <Demo2TreeDetail /> },
                    { path: 'web/moisture', element: <Demo2Moisture /> },
                    { path: 'web/alerts', element: <Demo2Alerts /> },
                    { path: 'web/work-management', element: <Demo2WorkManagement /> },
                    { path: 'web/work-history', element: <Demo2WorkHistory /> },
                    { path: 'web/reports', element: <Demo2Reports /> },
                    { path: 'web/settings', element: <Demo2Settings /> },
                ],
            },
            {
                element: <Demo2MobileLayout />,
                children: [
                    { path: 'mobile/home', element: <Demo2MHome /> },
                    { path: 'mobile/worklist', element: <Demo2MWorklist /> },
                    { path: 'mobile/map', element: <Demo2MMap /> },
                    { path: 'mobile/moisture', element: <Demo2MMoisture /> },
                    { path: 'mobile/history', element: <Demo2MHistory /> },
                ],
            },
        ],
    },
]);

export default router;
